// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_McD","requiredAsterisk":"Info_requiredAsterisk__10uLg"};